import React from "react";

function InsuranceTerms() {
  return (
    <div className="py-6">

      <p className="mb-10">Effective Date: March 18, 2025</p>
      <p className="mb-10">
        These Terms and Conditions (“Terms”) govern the access and use of our
        products and services for insurance companies (“Products”) provided by
        Novel AI Technologies, Inc. (“Company,” “we,” “our,” or “us”). By
        accessing or using the Products, you agree to be bound by these Terms.
      </p>

      <h2 className="font-bold text-xl mb-2">1. Acceptance of Terms</h2>
      <p className="mb-10">
        By accessing or using the Products, you acknowledge that you have read,
        understood, and agree to be bound by these Terms. If you do not agree,
        you must not access or use the Products. These Terms govern only the use
        of the Products and do not create any partnership, joint venture,
        employment, or agency relationship between the parties.
      </p>

      <h2 className="font-bold text-xl mb-2">2. Changes to Terms</h2>
      <p className="mb-10">
        We reserve the right to modify these Terms at any time. Changes will be
        effective upon publishing it on our website. Continued use after any
        modifications constitutes acceptance of the revised Terms. It is your
        responsibility to regularly review these Terms to stay informed of any
        updates.
      </p>

      <h2 className="font-bold text-xl mb-2">3. Access and Use of the Products</h2>
      <h3 className="font-bold mb-1">3.1 Permitted Use</h3>
      <ul className="list-disc ml-6 mb-10">
        <li>
          The Products provide analytics and insights to support insurance risk
          assessment.
        </li>
        <li>
          You may use the Products solely for internal business purposes and
          decision-making.
        </li>
      </ul>

      <h3 className="font-bold mb-1">3.2 Prohibited Use</h3>
      <ul className="list-disc ml-6 mb-10">
        <li>
          Disclose, distribute, sublicense, republish, upload, post, transmit,
          resell, or commercially exploit the Products or its outputs beyond
          internal use without prior written consent.
        </li>
        <li>
          Modify, duplicate, reproduce, reverse engineer, or create derivative
          works based on the Products.
        </li>
        <li>
          Attempt to re-identify de-identified or anonymized data provided
          through the Products.
        </li>
      </ul>

      <h3 className="font-bold mb-1">3.3 User Obligations and Restrictions</h3>
      <ul className="list-disc ml-6 mb-10">
        <li>
          You will not attempt to gain unauthorized access to any portion of the
          Products or its underlying systems.
        </li>
        <li>
          You agree to implement reasonable security measures on your end to
          protect any data you receive from the Products, but we shall not be
          responsible for any breaches or data loss on your systems.
        </li>
      </ul>

      <h2 className="font-bold text-xl mb-2">4. Data Ownership and Restrictions</h2>
      <ul className="list-disc ml-6 mb-10">
        <li>
          Novel AI Technologies, Inc. retains all ownership rights over the
          Products, including its AI models, algorithms, and analytics
          methodologies.
        </li>
        <li>
          You acknowledge that the data provided in the Products is proprietary
          to Novel AI Technologies, Inc. and does not grant any rights to you
          beyond those explicitly outlined in these Terms.
        </li>
        <li>
          We may share analytics outputs with third parties only in de-identified
          form.
        </li>
      </ul>

      <h2 className="font-bold text-xl mb-2">
        5. Disclaimers and Limitation of Liability
      </h2>
      <h3 className="font-bold mb-1">5.1 No Warranties</h3>
      <ul className="list-disc ml-6 mb-10">
        <li>
          The Products and their analytics are provided on an “as is” and “as
          available” basis, without warranties of any kind, either express or
          implied, including but not limited to accuracy, completeness,
          merchantability, fitness for a particular purpose, or non-infringement.
        </li>
        <li>
          We do not guarantee that the Products will be error-free,
          uninterrupted, or suitable for any specific use. Use of the Products is
          at your sole risk.
        </li>
      </ul>

      <h3 className="font-bold mb-1">5.2 Limitation of Liability</h3>
      <ul className="list-disc ml-6 mb-10">
        <li>
          In no event shall Novel AI Technologies, Inc. be liable for indirect,
          incidental, special, consequential, or punitive damages, including lost
          profits or business interruption. We are also not liable for any
          regulatory violations, underwriting errors, or claims disputes arising
          from the use of the Products.
        </li>
        <li>
          Your sole remedy for any dissatisfaction with the Products is to cease
          its use.
        </li>
        <li>
          Our total liability under these Terms shall not exceed the fees paid by
          the Insurance Company to Novel AI Technologies, Inc. in the one (1)
          month preceding the claim.
        </li>
      </ul>

      <h3 className="font-bold mb-1">5.3 Disclaimer</h3>
      <ul className="list-disc ml-6 mb-10">
        <li>
          The analytics provided are for informational purposes only and do not
          constitute professional advice or guarantees of future risk.
        </li>
        <li>
          Insurance companies assume all risk for integrating these analytics
          into decision-making processes and acknowledge that Novel AI
          Technologies, Inc. shall not be liable for any adverse business outcomes
          based on the use of these insights.
        </li>
      </ul>

      <h2 className="font-bold text-xl mb-2">
        6. Compliance and Regulatory Responsibilities
      </h2>
      <ul className="list-disc ml-6 mb-10">
        <li>
          The Insurance Company is solely responsible for ensuring that its use of
          the Products complies with applicable laws and regulations, including
          but not limited to data protection, insurance, and consumer rights laws.
        </li>
        <li>
          You agree to notify us immediately of any data breaches or suspected
          misuse of the Products’ data.
        </li>
      </ul>

      <h2 className="font-bold text-xl mb-2">7. Confidentiality</h2>
      <ul className="list-disc ml-6 mb-10">
        <li>
          You acknowledge that the Products contain proprietary and confidential
          information. You agree not to disclose any proprietary information
          obtained from the Products to third parties without prior written
          consent from Novel AI Technologies, Inc.
        </li>
        <li>This confidentiality obligation shall survive termination of these Terms.</li>
        <li>
          You shall not use our name, trademarks, or branding in any public
          statements, marketing materials, or regulatory filings without prior
          written approval.
        </li>
      </ul>

      <h2 className="font-bold text-xl mb-2">8. Indemnification</h2>
      <p className="mb-10">
        You agree to indemnify, defend, and hold harmless Novel AI Technologies,
        Inc. and its affiliates, officers, directors, employees, and agents from
        any claims, damages, liabilities, costs, or expenses (including legal
        fees) arising from:
      </p>
      <ul className="list-disc ml-6 mb-10">
        <li>Your use or misuse of the Products.</li>
        <li>Any violations of laws or regulations due to your use of the Products.</li>
        <li>
          Third-party claims arising from your reliance on the analytics provided
          by the Products.
        </li>
        <li>
          Any regulatory fines, penalties, or legal claims resulting from your
          failure to comply with laws and regulations.
        </li>
      </ul>

      <h2 className="font-bold text-xl mb-2">9. Termination</h2>
      <ul className="list-disc ml-6 mb-10">
        <li>We may terminate your access to the Products at any time if you breach these Terms.</li>
        <li>
          Upon termination, you must immediately cease using the Products and
          delete any stored data obtained from it.
        </li>
        <li>
          Termination of these Terms does not affect any obligations that have
          accrued prior to termination.
        </li>
      </ul>

      <h2 className="font-bold text-xl mb-2">
        10. Governing Law and Dispute Resolution
      </h2>
      <ul className="list-disc ml-6 mb-10">
        <li>
          These Terms shall be governed by the laws of the State of Delaware,
          without regard to its conflict of laws principles.
        </li>
        <li>
          Any disputes shall first be resolved through good-faith negotiations.
          If unresolved, disputes shall be submitted to binding arbitration in
          Delaware in accordance with the rules of a mutually agreed arbitration
          body.
        </li>
        <li>
          The parties waive any right to bring a class action or participate in a
          class-action lawsuit or class-wide arbitration.
        </li>
      </ul>

      <h2 className="font-bold text-xl mb-2">11. Entire Agreement</h2>
      <p className="mb-10">
        These Terms, along with any applicable agreements between Novel AI
        Technologies, Inc. and the Insurance Company, constitute the entire
        agreement governing your use of the Products and supersede all prior
        agreements or understandings. If any provision of these Terms is found to
        be unenforceable or invalid, that provision will be limited or eliminated
        to the minimum extent necessary, so that these Terms will otherwise remain
        in full force and effect.
      </p>

      <h2 className="font-bold text-xl mb-2">
        12. Electronic Signatures and Acceptance
      </h2>
      <p className="mb-10">
        By accessing and using the Products, you acknowledge and agree that these
        Terms are legally binding and enforceable.
      </p>
    </div>
  );
}

export default InsuranceTerms;